import { sdkTypes } from '@vansite/ts-sharetribe-flex-sdk';

const { LatLng, LatLngBounds } = sdkTypes;

const defaultSearchCountry = (lang) => {
  switch (lang) {
    case 'de':
      return {
        address: 'Deutschland',
        bounds: new LatLngBounds(new LatLng(55.1145, 15.04183), new LatLng(47.27023, 5.86631)),
      };
    case 'es':
      return {
        address: 'España',
        bounds: new LatLngBounds(new LatLng(43.7913, 4.3276), new LatLng(27.4333, -18.3937)),
      };
    case 'fr':
      return {
        address: 'France',
        bounds: new LatLngBounds(new LatLng(51.1242, 9.4783), new LatLng(41.3337, -5.5596)),
      };
    case 'it':
      return {
        address: 'Italia',
        bounds: new LatLngBounds(new LatLng(47.092, 18.7976), new LatLng(35.4892, 6.6267)),
      };
    default:
      return {
        address: 'Europe',
        bounds: new LatLngBounds(
          new LatLng(60.96919221, 22.9627664),
          new LatLng(34.07286958, -11.00958654)
        ),
      };
  }
};

export default defaultSearchCountry;
